import { computed, type Ref } from 'vue';
import type { CartItem } from '@cvo/ui';
import { useCartDisplayItems as useBaseCartDisplayItems } from '#layers/core/app/composables/useCartDisplayItems';
import { isFixedCartItem, type AllowedCartItem, type DefaultCartMeta } from '#layers/core/app/types/cart';

export function useCartDisplayItems<TExtra extends DefaultCartMeta = DefaultCartMeta>(items: Ref<Array<AllowedCartItem<TExtra>>>) {
  const { t } = useI18n();
  const { displayItems: baseDisplayItems } = useBaseCartDisplayItems(items);

  const displayItems = computed<CartItem[]>(() =>
    baseDisplayItems.value.map((displayItem, index) => {
      const originalItem = items.value[index];

      return isFixedCartItem(originalItem) && !originalItem.value ?
        { ...displayItem, value: t('ui.components.addons.included') }
        : displayItem;
    }));

  return { displayItems };
}
